export const SIX_PILLARS_SURVEY_REPORT =
  "Your 6 Pillars of Wellbeing Quiz Results";
export const BREAKDOWN_HEADER = "Breakdown by Pillar";
export const BREAKDOWN_SUBHEADER = "Over the past 7 days...";
